import React, { useState, useEffect } from "react";
import { InputLabel,  Typography, Button, CircularProgress, Box, Modal } from "@mui/material";
import axios from "axios";
import { BiErrorCircle } from "react-icons/bi";
import { FaRegCircleCheck } from "react-icons/fa6";
import { useUserAdmin } from "../../../../admin/UserContext";
import { IoClose } from "react-icons/io5";

export const EditarInfoJofemar = ({ onclose, slider, fetchSliders }) => {
    const { Token } = useUserAdmin();
    const backendURL = process.env.REACT_APP_BACKEND_URL;

    const [formData, setFormData] = useState({
     
        titulo: "",
        subtitulo: "",
       
    });


    const [loading, setLoading] = useState(false);
    const [successAlertOpen, setSuccessAlertOpen] = useState(false);
    const [errorAlertOpen, setErrorAlertOpen] = useState(false);
    const [enviandoAlert, setEnviandoAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");


    // Obtener datos iniciales del slider
    useEffect(() => {
        const fetchSlider = async () => {
            try {
                const response = await axios.get(`${backendURL}/api/portadajomefar/admin/${slider}`, {
                    headers: { Authorization: `Bearer ${Token}` },
                });
                const data = response.data;
                setFormData({
                  
                    titulo: data.titulo || null,
                    subtitulo: data.subtitulo || null,
                  


                });
            } catch (error) {
                console.error("Error al obtener slider:", error);
            }
        };
        fetchSlider();
    }, [slider, backendURL, Token]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

  

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setEnviandoAlert(true);

        const data = new FormData();
        Object.entries(formData).forEach(([key, value]) => {
            if (value) data.append(key, value);
        });

        try {
            await axios.post(`${backendURL}/api/editar/portadajomefar/${slider}`, data, {
                headers: {
                    Authorization: `Bearer ${Token}`,
                    'Content-Type': 'multipart/form-data',
                },
            });

            setAlertMessage("Actualizado correctamente.");
            setSuccessAlertOpen(true);

        } catch (error) {
            setAlertMessage("Error al actualizar.");
            setErrorAlertOpen(true);
            console.error("Error al actualizar:", error);
        } finally {
            setLoading(false);
            setEnviandoAlert(false);
            await fetchSliders()
            setTimeout(() => {
                setSuccessAlertOpen(false);
                setEnviandoAlert(false)
                setErrorAlertOpen(false);
                onclose();

            }, 3000);
        }
    };

   
    return (
        <Box p={3}>
            <Typography variant="h5" gutterBottom sx={{ color: "#585857" }}>
               Editar Infomarcion Jofemar
            </Typography>

            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '25px' }}>

                
                <div>
                    <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Titulo</InputLabel>

                    <input
                        name="titulo"
                        label="Título"
                        value={formData.titulo}
                        onChange={handleInputChange}
                        style={{ border: "2px solid #585857", color: '#585857', background: '#fff', padding: "8px", borderRadius: "6px", width: "100%" }}
                    />
                </div>
                <div>
                    <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Subtitulo</InputLabel>

                    <input
                        name="subtitulo"
                        label="Título"
                        value={formData.subtitulo}
                        onChange={handleInputChange}
                        style={{ border: "2px solid #585857", color: '#585857', background: '#fff', padding: "8px", borderRadius: "6px", width: "100%" }}
                    />
                </div>
               
                <Button
                    variant="contained"
                    disabled={loading}
                    sx={{
                        backgroundColor: "#5E487B",
                        color: "#fff",
                        textTransform: "capitalize"
                    }}
                    type="submit"
                >    {loading ? <CircularProgress size={24} /> : 'Editar porcentaje'}

                </Button>
            </form>
            <Modal open={successAlertOpen} onClose={() => setSuccessAlertOpen(false)}>
                <Box sx={modalStyle}>
                    <section className="closemodal" onClick={() => setSuccessAlertOpen(false)}>
                        <IoClose style={{ color: '#585857' }} />
                    </section>
                    <section style={{ textAlign: 'center' }}>
                        <FaRegCircleCheck style={{ color: 'green', fontSize: '2rem', marginBottom: '1rem' }} />
                        <p>{alertMessage}</p>
                    </section>
                </Box>
            </Modal>

            {/* Modal de error */}
            <Modal open={errorAlertOpen} onClose={() => setErrorAlertOpen(false)}>
                <Box sx={modalStyle}>
                    <section className="closemodal" onClick={() => setErrorAlertOpen(false)}>
                        <IoClose />
                    </section>
                    <section style={{ textAlign: 'center' }}>
                        <BiErrorCircle style={{ color: 'red', fontSize: '2rem', marginBottom: '1rem' }} />
                        <p>{alertMessage}</p>
                    </section>
                </Box>
            </Modal>

            {/* Modal de progreso */}
            <Modal open={enviandoAlert} onClose={() => setEnviandoAlert(false)}>
                <Box sx={modalStyle}>
                    <section className="closemodal" onClick={() => setErrorAlertOpen(false)}>
                        <IoClose />
                    </section>
                    <section style={{ textAlign: 'center', padding: '1rem' }}>
                        <CircularProgress style={{ color: '#694B81' }} />
                        <p>Procesando solicitud...</p>
                    </section>
                </Box>
            </Modal>
        </Box>
    );
};




const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: '#ffff',
    border: '0px solid #000',
    boxShadow: 24,
    p: 4,
    borderRadius: '10px'
};
